export default "__VITE_PUBLIC_ASSET__0bfd241f__"